import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HomePage } from './pages/Home';
import { GalleryPage } from './pages/GalleryPage';
import { BookingPage } from './components/booking/BookingPage';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import './App.css';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

function App() {
  const [language, setLanguage] = useState<string>('en');
  const { t } = useTranslation();
  
  // Function to toggle language
  const toggleLanguage = () => {
    const newLang = language === 'en' ? 'pt' : 'en';
    setLanguage(newLang);
    i18n.changeLanguage(newLang);
  };
  
  // Effect to sync language state with i18n
  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);
  
  return (
    <Router>
      <div className="app">
        <Header 
          language={language} 
          toggleLanguage={toggleLanguage}
        />
        <main>
          <Routes>
            <Route path="/" element={<HomePage language={language} />} />
            <Route path="/gallery" element={<GalleryPage language={language} />} />
            <Route path="/booking" element={<BookingPage language={language} />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer language={language} />
      </div>
    </Router>
  );
}

export default App;
